import PropTypes from 'prop-types';
import { find, path, propEq } from 'ramda';
import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';

import CardHeader from '@material-ui/core/CardHeader';
import Divider from '@material-ui/core/Divider';

import { connect } from 'react-redux';
import { readEndpoint, updateResource } from 'redux-json-api';

import { closeLeftBarModule, showSnackbarMessage } from '../../modules/actions/layout';
import RailwayForm from "./Form";
import {SubmissionError} from "redux-form";

class RailwayEdit extends Component {
  static propTypes = {
    apiEndpoint: PropTypes.string.isRequired,
    closeLeftBarModule: PropTypes.func.isRequired,
    extra: PropTypes.shape({}),
    readEndpoint: PropTypes.func.isRequired,
    showSnackbarMessage: PropTypes.func.isRequired,
    updateResource: PropTypes.func.isRequired,
  };

  render() {
    const { closeLeftBarModule, showSnackbarMessage, railway, updateResource } = this.props;
    const initialValues = {
      'name': railway.attributes.name,
      'phone-number': railway.attributes['phone-number'],
    };

    return (
      <Grid fluid>
        <Row>
          <Col style={{ margin: 20, width: '100%' }}>
            <CardHeader title="Spoorweg wijzigen" />

            <Divider />

            <RailwayForm
              initialValues={initialValues}
              onSubmit={async (values) => {
                const resource = {
                  type: 'railway',
                  id: railway.id,
                  attributes: {
                    name: values.name,
                    'phone-number': values['phone-number']
                  }
                }

                try {
                  await updateResource(resource)

                  closeLeftBarModule('railwayAdmin');
                  showSnackbarMessage('Spoorweg succesvol bewerkt');
                } catch (error) {
                  showSnackbarMessage('Er is iets misgegaan bij het bewerken van de spoorlijn.')
                  throw new SubmissionError(error)
                }
              }}
            />
          </Col>
        </Row>
      </Grid>
    );
  };
}

function selectRailway(state, id) {
  const railways = state.api.railway && state.api.railway.data || [];

  return find(propEq('id', id))(railways);
}

const mapStateToProps = (state, ownProps) => ({
  apiEndpoint: path(['api', 'endpoint', 'axiosConfig', 'baseURL'], state),
  railway: selectRailway(state, ownProps.extra.id),
});

const mapDispatchToProps = {
  closeLeftBarModule,
  readEndpoint,
  showSnackbarMessage,
  updateResource,
};

export default connect(mapStateToProps, mapDispatchToProps)(RailwayEdit);
